import { api } from '../client';

export interface Vendor {
  _id: string;
  vendor_id: string;
  name: string;
  username: string;
  email?: string;
  phone?: string;
  status: 'active' | 'inactive' | 'suspended';
  tenant_id: string;
  tenant_name?: string;
  subdomain?: string;
  settings: {
    portal_enabled: boolean;
    max_screens: number;
    session_ttl_days: number;
  };
  active_sessions: Array<{
    session_id: string;
    ip?: string;
    user_agent?: string;
    logged_in_at: string;
    expires_at?: string;
  }>;
  last_login?: string;
  created_by?: { _id: string; username: string } | null;
  device_count?: number;
  connected_count?: number;
  createdAt: string;
  updatedAt: string;
}

export interface VendorsListResponse {
  success: boolean;
  vendors: Vendor[];
  total: number;
  page: number;
  totalPages: number;
}

export interface VendorDetailResponse {
  success: boolean;
  vendor: Vendor;
  device_stats: { total: number; connected: number };
}

export interface TenantSearchResult {
  _id?: string;
  id?: string;
  tenant_id?: string;
  name?: string;
  tenant_name?: string;
  subdomain?: string;
}

export interface VendorsParams {
  page?: number;
  limit?: number;
  search?: string;
}

export interface CreateVendorData {
  name: string;
  username: string;
  password: string;
  email?: string;
  phone?: string;
  tenant_id: string;
  tenant_name?: string;
  subdomain?: string;
  settings?: {
    max_screens?: number;
    session_ttl_days?: number;
  };
}

export interface UpdateVendorData {
  name?: string;
  email?: string;
  phone?: string;
  status?: string;
  tenant_id?: string;
  tenant_name?: string;
  subdomain?: string;
  settings?: {
    portal_enabled?: boolean;
    max_screens?: number;
    session_ttl_days?: number;
  };
}

export const vendorsApi = {
  list: (params: VendorsParams = {}) =>
    api.get<VendorsListResponse>('/api/vendors', params as Record<string, string | number>),

  get: (id: string) =>
    api.get<VendorDetailResponse>(`/api/vendors/${id}`),

  create: (data: CreateVendorData) =>
    api.post<{ success: boolean; vendor: Vendor; error?: string }>('/api/vendors', data),

  update: (id: string, data: UpdateVendorData) =>
    api.put<{ success: boolean; vendor: Vendor; error?: string }>(`/api/vendors/${id}`, data),

  delete: (id: string) =>
    api.delete<{ success: boolean }>(`/api/vendors/${id}`),

  resetPassword: (id: string, password: string) =>
    api.post<{ success: boolean; error?: string }>(`/api/vendors/${id}/reset-password`, { password }),

  deleteSession: (vendorId: string, sessionId: string) =>
    api.delete<{ success: boolean }>(`/api/vendors/${vendorId}/sessions/${encodeURIComponent(sessionId)}`),

  searchTenants: (query: string) =>
    api.get<{ success: boolean; tenants: TenantSearchResult[] }>(
      '/api/posist/tenants/search', { q: query }
    ),
};
